import script from "./TableImage.vue?vue&type=script&setup=true&lang=js"
export * from "./TableImage.vue?vue&type=script&setup=true&lang=js"

import "./TableImage.vue?vue&type=style&index=0&id=66ab6f9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66ab6f9a"]])

export default __exports__